export const services = [
  {
    id: 1,
    icon: 'ri-award-line',
    title: '인증·통관 전담',
    short_desc: '한국·베트남 양국의 복잡한 인증을 원스톱으로 처리합니다',
    description: '식약처(MFDS), CR, HACCP 등 양국의 식품·화장품·건강기능식품 인증을 전담 처리합니다. 수입 통관부터 라벨링 현지화까지 행정 전반을 모나루가 책임지기 때문에, 브랜드는 제품 품질에만 집중하면 됩니다.',
    features: ['식약처(MFDS) 인증 대행', 'CR(베트남) 인증 취득', 'HACCP·유기인증 지원', '수입 통관 서류 완비', '라벨링·표시 현지화'],
    image_url: 'https://public.readdy.ai/ai/img_res/0f53bf389bfadb535018b96aa54b8492.jpg',
    sort_order: 1,
  },
  {
    id: 2,
    icon: 'ri-store-3-line',
    title: '유통 채널 입점',
    short_desc: '대형마트·편의점·온라인 플랫폼 등 메이저 채널에 직접 연결합니다',
    description: '이마트, CU, GS25, 쿠팡, 무신사 등 한국 메이저 유통망과 Big C, Lotte Mart, Shopee, Lazada 등 베트남 주요 채널에 직접 연결합니다. 수년간 쌓아온 바이어 네트워크로 빠른 입점과 안정적인 물량 확보를 지원합니다.',
    features: ['대형마트·슈퍼 입점 협상', '편의점 체인 직접 연결', '이커머스 채널 개설', '수출입 물량 관리', '재고·발주 시스템 연동'],
    image_url: 'https://readdy.ai/api/search-image?query=modern%20Korean%20supermarket%20hypermarket%20bright%20clean%20store%20aisle%20shelving%20products%20displayed%20neatly%20professional%20retail%20distribution%20channel%20consumer%20goods%20vibrant%20clean%20interior%20shopping%20mall%20Korea&width=800&height=560&seq=svc_dist1&orientation=landscape',
    sort_order: 2,
  },
  {
    id: 3,
    icon: 'ri-palette-line',
    title: '브랜드 현지화',
    short_desc: '양국 소비자 트렌드에 맞춘 마케팅 전략으로 브랜드를 정착시킵니다',
    description: '브랜드 네임·슬로건 현지화부터 패키지 디자인, SNS 마케팅, 인플루언서 협업까지 종합 현지화 서비스를 제공합니다. 한국과 베트남 소비자 심리를 깊이 이해하는 전문가 팀이 브랜드 스토리를 현지 언어로 재해석합니다.',
    features: ['브랜드 네이밍·슬로건 번역', '패키지 디자인 현지화', 'SNS·인플루언서 마케팅', '소비자 조사 및 트렌드 분석', '론칭 이벤트 기획'],
    image_url: 'https://readdy.ai/api/search-image?query=creative%20brand%20localization%20design%20studio%20modern%20workspace%20Korean%20Vietnamese%20branding%20packaging%20design%20professional%20marketing%20team%20color%20swatches%20mood%20boards%20clean%20minimal%20navy%20accent%20contemporary%20office&width=800&height=560&seq=svc_brand1&orientation=landscape',
    sort_order: 3,
  },
  {
    id: 4,
    icon: 'ri-map-pin-2-line',
    title: '시장 진입 컨설팅',
    short_desc: '한국·베트남 시장 진입을 위한 전략적 로드맵을 제시합니다',
    description: '신규 시장 진출 시 가장 중요한 것은 정확한 시장 분석과 현실적인 전략 수립입니다. 모나루는 타깃 소비자 분석, 경쟁사 매핑, 가격 전략, 법인 설립 지원까지 진출 전 과정을 동반합니다.',
    features: ['시장 타당성 조사', '소비자·경쟁사 분석', '가격·채널 전략 수립', '현지 파트너 매칭', '법인 설립·정부 창구 연결'],
    image_url: 'https://readdy.ai/api/search-image?query=executive%20business%20strategy%20consulting%20meeting%20modern%20glass%20boardroom%20Seoul%20skyline%20panoramic%20professional%20businesspeople%20discussing%20market%20entry%20roadmap%20charts%20maps%20corporate%20planning%20navy%20silver%20interior%20elegant%20contemporary&width=800&height=560&seq=svc_entry1&orientation=landscape',
    sort_order: 4,
  },
  {
    id: 5,
    icon: 'ri-search-eye-line',
    title: '브랜드 소싱·발굴',
    short_desc: '베트남 프리미엄 브랜드를 직접 발굴해 한국 시장에 소개합니다',
    description: '모나루는 베트남 현지에서 직접 프리미엄 브랜드를 발굴하고, 품질 검증·독점 계약을 통해 한국 시장에 소개합니다. 국내 유통망 입점, 홍보, 소비자 교육까지 전담하여 베트남 브랜드의 성공적인 한국 데뷔를 책임집니다.',
    features: ['베트남 브랜드 현지 발굴', '품질·안전 검증 프로세스', '독점 수입 계약 체결', '한국 유통망 론칭', 'B2B 공급망 구축'],
    image_url: 'https://readdy.ai/api/search-image?query=curated%20premium%20Vietnamese%20product%20brand%20discovery%20sourcing%20high%20quality%20artisan%20goods%20beautiful%20packaging%20arranged%20on%20clean%20white%20minimal%20surface%20professional%20product%20photography%20elegant%20navy%20accent%20contemporary%20lifestyle&width=800&height=560&seq=svc_source1&orientation=landscape',
    sort_order: 5,
  },
  {
    id: 6,
    icon: 'ri-truck-line',
    title: '물류·배송 관리',
    short_desc: '한국-베트남 간 해상·항공 물류를 안전하고 신속하게 처리합니다',
    description: '부산·인천에서 호치민·하이퐁까지, 해상 컨테이너부터 항공 특송까지 모나루가 물류 전 과정을 관리합니다. 실시간 화물 추적 시스템과 온도 제어 보관 시설로 제품이 최상의 상태로 도착하도록 보장합니다.',
    features: ['해상·항공 복합 운송', '실시간 화물 추적', '온도 관리 냉장 물류', '보세 창고 운영', '라스트마일 배송 연결'],
    image_url: 'https://readdy.ai/api/search-image?query=modern%20logistics%20warehouse%20interior%20high-tech%20automated%20racking%20system%20clean%20bright%20professional%20cargo%20management%20facility%20Korea%20Vietnam%20trade%20route%20container%20shipping%20navy%20accent%20silver%20metallic%20tones%20organized%20storage&width=800&height=560&seq=svc_logi1&orientation=landscape',
    sort_order: 6,
  },
];
